import { format } from 'date-fns';

export function formatBytes(bytes: number, decimals: number = 1) {
  if (!+bytes) {
    return '0 Bytes';
  }

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GiB', 'TiB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}

export function formatGiB(gibValue: number | undefined, decimals: number = 1): string {
  if (gibValue === null || gibValue === undefined || isNaN(gibValue)) {
    return 'N/A';
  }
  if (gibValue === 0) {
    return '0 Bytes';
    // return '0 GiB';
  }

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];

  const i = Math.floor(Math.log(Math.abs(gibValue)) / Math.log(k));

  const unitIndex = Math.min(i, sizes.length - 1);

  const convertedValue = gibValue / Math.pow(k, unitIndex);

  const numStr = convertedValue.toFixed(dm);
  const formattedNum = parseFloat(numStr);

  return `${formattedNum} ${sizes[unitIndex]}`;
}

export function convertToGIB(value: number): string {
  const gigabytes = value / (1024 * 1024 * 1024);
  return `${gigabytes.toFixed(0)} GiB`;
}

export const PositiveDecimalRegex = /^(([1-9]\d*(\.\d+)?)|(\d{1,3}(,\d{3})*(\.\d+)?)|(0\.\d+))$/;

export const numValueOrDefault = (
  v: number | string | undefined | null,
  def: number,
  _debugName?: string
) => {
  const v1 = v === undefined || v === '' || v === null || isNaN(Number(v)) ? def : Number(v);
  //console.log({ v, v1, d: _debugName });
  return v1;
};

export function formatDate(date: string | Date, showTime?: boolean): string {
  return format(
    typeof date === 'string' ? new Date(date) : date,
    showTime ? 'yyyy/MM/dd | HH:mm' : 'yyyy/MM/dd'
  );
}

export const dollarComparator = (valueA: string, valueB: string) => {
  if (valueA === 'N/A' && valueB === 'N/A') {
    return 0;
  }
  if (valueA === 'N/A') {
    return 1;
  }
  if (valueB === 'N/A') {
    return -1;
  }
  const numA = parseFloat(valueA.replace('$', ''));
  const numB = parseFloat(valueB.replace('$', ''));
  return numA - numB;
};

export function formatBytesWithValueAndUnit(bytes: number, decimals: number = 1) {
  if (bytes === null || bytes === undefined || isNaN(bytes)) {
    return { value: 'N/A', unit: null };
  }
  if (bytes === 0) {
    return { value: 0, unit: 'GiB' };
  }

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(Math.abs(bytes)) / Math.log(k));

  const unitIndex = Math.min(i, sizes.length - 1);

  const convertedValue = bytes / Math.pow(k, unitIndex);

  const numStr = convertedValue.toFixed(dm);
  const formattedNum = parseFloat(numStr);

  return { value: formattedNum, unit: sizes[unitIndex] };
}
